import { render, staticRenderFns } from "./eComplaintPrivacyModal.vue?vue&type=template&id=23b6afd8"
import script from "./eComplaintPrivacyModal.vue?vue&type=script&lang=js"
export * from "./eComplaintPrivacyModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports